<template>
  <div class="news" @click="Jujiao=''">
    <div class="coverage" v-if="coverageShow"> 
      <div class="coverageCont">
        <div class="coverageScroll">
          <div class="xxhd">
            <a href="#" class="scroll-icon"></a>
            <span class="xxhdText">请向下滑动</span>
          </div>
          <span class="closeD" @click="closeD()">+</span>
          <img v-show="detaImg" :src="detaImg">
          <div v-show="htmlNew" v-html="htmlNew"></div>
        </div>
      </div>
    </div>
    
    <swiper :options="swiperOption" ref="mySwiper" v-if="false">
      <swiper-slide v-for="(i,index) in bannerImg" :key='index'>
          <img :src="i" class="swiperImg">
      </swiper-slide>
    </swiper>

    <!-- <div class="zhanwei">
../../assets/img/news/banner1.jpg
    </div> -->


    <div class="titleTY">
      <span class="titleTY_top">
        新闻动态
      </span>
      <span class="titleTY_bot">
        HOT NEWS
      </span>
    </div>

    <!-- <div class="clientCon2" id="clientCon2" style="margin-top:80px;margin-bottom:80px;" data-aos=""  data-aos-duration="1200">
      <div class="clientCon21 contentWidth">
        <div class="clientCon21_left">
          <div class="clientAbout">
            <span class="clientAbout_top">
              HOT NEWS
            </span><br>
            <span class="clientAbout_bot">
              新闻动态
            </span>
            <p></p>
          </div>
        </div>
      </div>
    </div> -->

    <div class="newsCon2" id="newsCon2">
      <!-- <div class="newsCon11 contentWidth">
        <div class="newsCon11_left">
          <img src="../../assets/img/index/sb.png" alt="">
          <div class="newsAbout">
            <span class="newsAbout_top">
              HOT NEWS
            </span><br>
            <span class="newsAbout_bot">
              新闻动态
            </span>
          </div>
        </div>
        <div class="newsCon11_right">
          <span></span>
          <p>
            <span>北京数聚智连科技股份有限公司（原北京蓝色光标电子商务股份有限公司）于2016年5月份正式在新三板独立挂牌上市（股票代码：837467）</span>
          </p>
        </div>
      </div> -->
    </div>
    <div class="newsCon3">
      <div class="newsCon31 contentWidth">
        <div :class="Jujiao==i.id?'newsList jujiaoNewsList':'newsList'" v-for="(i,index) in Listdata" :id="i.id">
          <img :src="i.img" alt="">
          <div>
            <span>
              {{i.title}}
            </span>
            <p>
              {{i.cont}}
              <i v-if="i.details" @click="openD(i.deta)">详情>></i>
              <i v-if="i.detailsVideo" @click="openDV(i.video)">详情>></i>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ZSelect from '../modules/Zselect'
export default {
  name: 'news',
  components:{ZSelect},
  data () {
    return {
      Jujiao:'',
      coverageShow:false,//遮罩是否显示详情
      detaImg:'',//遮罩图片地址
      htmlNew:'',
      bannerImg:[
        require('../../assets/img/news/banner5.jpg'),
        require('../../assets/img/news/banner6.jpg'),
        require('../../assets/img/news/banner7.jpg'),
        // require('../../assets/img/news/banner4.jpg'),
      ],
      test1:'1',
      test2:'1',
      msgs: [{
        ids:1,
        value1:'我是1'
      },{
        ids:2,
        value1:'我是2'
      },{
        ids:3,
        value1:'我是3'
      },{
        ids:4,
        value1:'我是4'
      },],
      swiperOption:{
        loop:true,
        effect:'fade',
        notNextTick: true,
        mousewheelControl: true,
        autoplayDisableOnInteraction:false,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        paginationClickable: true,
        autoplay : {
          delay:4000    
        },
        observer:true,
        speed:1000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
      Con1:0,
      Con2:0,
      Con3:0,
      ImgHover:0,
      newslistIndex:0,
      Listdata:[
        {
          title:'双喜临门！数聚智连斩获2026天猫国际金星服务商及餐线行业银星服务商认证',
          id:'news20260520',
          img:require('../../assets/img/news/74.png'),
          cont:'在刚刚落幕的2026天猫国际服务商生态大会上，数聚智连凭借扎实的运营实力、高效的服务能力和亮眼的业绩表现，一举斩获2026年天猫国际金星服务商认证，同时在餐线行业专项评选中，我们也成功拿下2026餐线行业银星服务商荣誉！这两项沉甸甸的奖项，不仅是天猫平台对我们专业能力的权威认可，更是每一位数聚智连人并肩作战、全力以赴的勋章。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/73 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/73 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/73 (3).jpg')+
          '">'
        },
        {
          title:'东连科技四年蝉联！再度斩获京东健康年度卓越代运营服务商"铁冬青"奖!',
          id:'news20260429',
          img:require('../../assets/img/news/73.png'),
          cont:'近日，京东健康正式公布2026年度“铁冬青”奖获奖名单，东连（北京）科技有限公司凭借持续领先的服务能力、稳健创新的运营模式与优异的消费者口碑，再度获评2026年度卓越代运营服务商，蝉联这项京东健康服务商领域的至高荣誉，持续领跑健康电商代运营赛道。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/72 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/72 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/72 (3).jpg')+
          '">'
        },
        {
          title:'七年蝉联！东连科技再度斩获京东代运营服务年度奖项“京卓越”奖！',
          id:'news20260424',
          img:require('../../assets/img/news/72.png'),
          cont:'近日，京麦服务市场正式揭晓2026年度“京卓越”服务商名单，东连科技凭借行业领先的全链路运营能力、技术创新实力与品牌增长实效，从众多服务商中脱颖而出，连续七年摘得京东代运营领域最高荣誉“京卓越”奖。此次获奖不仅是京东官方对东连科技综合实力的再度认可，更印证了东连科技在电商行业向高质量、数字化、精细化转型背景下，持续领跑行业的核心竞争力。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/71 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/71 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/71 (3).jpg')+
          '">'
        },
        {
          title:'数聚智连荣膺2026天猫生态五星经营服务商认证，全链路实力铸就长期主义标杆',
          id:'news20260327',
          img:require('../../assets/img/news/71.png'),
          cont:'2026年3月25日，天猫生态中心在星级酒会上正式发布2026天猫生态「星级认证」名单，北京数聚智连科技股份有限公司凭借深厚的全域经营底蕴、卓越的全链路运营能力以及持续的增长潜力，成功斩获天猫生态五星经营服务商认证。此次认证是天猫平台对数聚智连在电商运营领域专业实力与经营成果的高度认可，更是对公司长期深耕天猫生态、助力品牌实现高质量增长的权威加持。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/70 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/70 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/70 (3).jpg')+
          '">'
        },
        {
          title:'数聚智连斩获2026年天猫生态快消行业认证，彰显垂直领域专业硬实力！',
          id:'news20260305',
          img:require('../../assets/img/news/70.jpg'),
          cont:'2026年2月27日，天猫生态正式发布2026年度「行业认证」名单，北京数聚智连科技股份有限公司凭借在快消领域深耕多年的专业运营能力、对行业趋势的精准洞察以及丰富的实操经验，成功入选快消行业店铺运营认证名单，这是天猫生态对公司在快消垂直领域经营深度与专业实力的权威认可。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/69 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/69 (2).jpg')+
          '">'
        },
        {
          title:'东连科技连续三年荣获京东健康年度卓越代运营服务商“铁冬青”奖！',
          id:'news20250507',
          img:require('../../assets/img/news/69.jpg'),
          cont:'近日，京东健康正式公布2025年度“铁冬青奖”获奖名单。东连（北京）科技有限公司凭借卓越的服务能力、创新的运营模式及优质的消费者口碑，从众多服务商中脱颖而出，荣获2025“卓越代运营服务商”，成为京东健康生态服务标杆。这一荣誉不仅是对东连科技专业实力的高度认可，更是对其深耕健康电商领域、助力品牌与平台共赢的持续肯定。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/68 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/68 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/68 (3).jpg')+
          '">'
        },
        {
          title:'东连科技连续六年荣获京东代运营服务年度奖项“京卓越”奖！',
          id:'news20250401',
          img:require('../../assets/img/news/68.jpg'),
          cont:'2025年4月1日，京东正式揭晓“2025年京卓越合作伙伴”名单，东连科技凭借在电商代运营领域的全渠道整合能力、数据化运营实力及品牌增长赋能，从数千家服务商中脱颖而出，成为全国 20 家获此殊荣的企业之一。这也是东连科技连续六年获得京东“京卓越”奖项，充分展现了京东官方对东连科技运营能力的高度认可。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/67 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/67 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/67 (3).jpg')+
          '">'
        },
        {
          title:'北京数聚智连科技股份有限公司获得高新技术企业证书',
          id:'news20250327',
          img:require('../../assets/img/news/67.jpg'),
          cont:'根据《高新技术企业认定管理办法》（国科发火〔2016〕32号）和《高新技术企业认定管理工作指引》（国科发火〔2016〕195号）有关规定，北京数聚智连科技股份有限公司获得由北京市科学技术委员会、北京市财政局、国家税务总局北京市税务局联合颁发的高新技术企业证书。这标志着数聚智连在自主知识产权、科技成果转化以及研发项目的组织管理水平等方面得到了国家级的权威认可。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont66 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont66 (2).jpg')+
          '">'
        },
        {
          title:'北京数聚智连科技股份有限公司荣获“中关村高新技术企业”认证！',
          id:'news0',
          img:require('../../assets/img/news/66.jpg'),
          cont:'2025年新春伊始，数聚智连获得中关村高新技术企业认证。这一认证标志着对公司在科技创新能力、研发成果转化及综合实力的认可。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont65 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont65 (2).jpg')+
          '">'
        },
        {
          title:'数聚智连旗下榴莲营销斩获2024年度TBI杰出品牌创新奖三项金奖！',
          id:'news1',
          img:require('../../assets/img/news/65.jpg'),
          cont:'2024第五届TBI杰出品牌创新节以“回归本质”为主题，于12月26-27日在上海隆重举办！评审专家通过多角度观察、深入讨论与评选，最终选拔出了在本年度表现杰出的参赛作品。数聚智连旗下榴莲营销从高达1654件参赛作品中脱颖而出，荣获三项金奖！',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont64 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont64 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont64 (3).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont64 (4).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont64 (5).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont64 (6).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont64 (7).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont64 (8).jpg')+
          '">'
        },
        {
          title:'数聚智连荣获2024北京服务业企业百强榜单第79名！',
          id:'news2',
          img:require('../../assets/img/news/64.jpg'),
          cont:'12月24日，由中国企业联合会、中国企业家协会发布的北京企业百强等多项榜单中，数聚智连凭借在电商和营销领域的卓越表现和创新能力，成功入选“2024年北京服务业企业百强”第79名。数聚智连作为中央大力提倡的数字经济中促进消费的核心一环，植根北京，服务全国，不断提高自身竞争力和服务水平，获得客户的认可，取得稳定的业绩增长。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont63 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont63 (2).jpg')+
          '">'
        },
        {
          title:'数聚智连荣登“天猫快消行业生态荣誉合作伙伴”榜单！',
          img:require('../../assets/img/news/63.jpg'),
          cont:'经多维评估，2024年“天猫快消行业生态荣誉合作伙伴”榜单正式发布，数聚智连凭借深耕于母婴快消领域多年培育出来的精细化运营经验、强大的市场洞察能力以及优秀品牌服务能力，荣获淘天集团2024行业年度服务商推荐。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont62 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont62 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont62 (3).jpg')+
          '">'
        },
        {
          title:'东连科技喜获2023年年度京东代运营双“卓越”！',
          id:'news4',
          img:require('../../assets/img/news/62.jpg'),
          cont:'近日，京东平台官方公布了2023年度京东服务商重磅大奖“京卓越”的获奖名单，东连科技连续五年获得代运营“京卓越”合作伙伴大奖，这是京东官方平台一年一度公布的服务商最高级别奖项。同时，在今年京东官方新设立的京东健康“卓越”合作伙伴大奖中，东连科技再摘一冠。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont61 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont61 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont61 (3).jpg')+
          '">'
        },
        {
          title:'东连科技荣获京东零售“2023年度优秀代运营服务商”重磅大奖！',
          img:require('../../assets/img/news/61.png'),
          cont:'12月5日，以“服务无界、展翼未来”为主题的，2023年度京东零售商家服务峰会在京东总部1号楼隆重举行，这是一场京东零售集团面向全体京东零售商家的服务盛会，大会涵盖倾听用户声音、洞察行业服务水平、表彰服务领先商家等三大环节。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont61_01.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont61_02.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont61_03.jpg')+
          '">'
        },
        {
          title:'数聚智连荣获2023舒尔合作伙伴峰会 【FY23年度市场先锋奖】',
          img:require('../../assets/img/news/60.png'),
          cont:'2023年7月19日，疫情3年后，期待已久的舒尔合作伙伴会议如及时雨一般在苏州召开，数聚智连旗下“北联伟业”作为Shure 核心FP受邀参会并脱颖而出，荣获舒尔“FY23年度市场先锋奖”。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont60 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont60 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont60 (3).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont60 (4).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont60 (5).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont60 (6).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont60 (7).jpg')+
          '">'
        },
        {
          title:'数聚智连荣获2023TopDigital创新营销奖三项大奖！',
          img:require('../../assets/img/news/59.png'),
          cont:'7月14日，备受瞩目的2023第十一届TopDigital创新营销奖获奖结果正式揭晓。据悉，经过近百位评审团有效初评、复评及终评。数聚智连选送案例从海内外657家参赛企业提交的3052件作品中突出重围，最终斩获2023第11届TopDigital创新营销奖年度专项大奖、银奖和铜奖！',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont59 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont59 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont59 (3).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont59 (4).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont59 (5).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont59 (6).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont59 (7).jpg')+
          '">'
        },
        {
          title:'数聚智连荣获虎啸奖四项大奖！',
          img:require('../../assets/img/news/58.png'),
          cont:'近日，2023年第十四届虎啸奖颁奖典礼于上海圆满落幕，数聚智连营销机构喜获四大奖项。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont58_01.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont58_02.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont58_03.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont58_04.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont58_05.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont58_06.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont58_07.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont58_08.jpg')+
          '">'
        },
        {
          title:'数聚智连助力好欢螺荣获第14届金鼠标“数字营销最具创新精神品牌”奖',
          img:require('../../assets/img/news/57.png'),
          cont:'2023年5月19日，2023年第14届金鼠标国际数字营销节在京举行，揭晓多项备受行业关注的营销大奖。数聚智连助力好欢螺摘得“数字营销最具创新精神品牌”奖！',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont57 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont57 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont57 (3).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont57 (4).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont57 (5).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont57 (6).jpg')+
          '">'
        },
        {
          title:'东连科技荣获京东健康年度卓越代运营服务商“铁冬青”奖',
          id:'news10',
          img:require('../../assets/img/news/56.png'),
          cont:'近日，京东健康公布“铁冬青”奖2022年度服务商获奖名单，奖项花落各家。东连科技凭借专业的服务能力及优质的消费者口碑从多家候选团队中脱颖而出，荣获京东健康“铁冬青”奖2022年度卓越代运营服务商。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont56 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont56 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont56 (3).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont56 (4).jpg')+
          '">'
        },
        {
          title:'数聚智连斩获m awards年度新品打爆增长奖大奖',
          img:require('../../assets/img/news/55.png'),
          cont:'3月30日，「2023全球品牌经营大赏暨m awards颁奖盛典」重磅揭晓，数聚智连携手帮宝适品牌从众多入围案例中脱颖而出，斩获【年度新品打爆增长奖 大奖】，这也是我们代表品牌参赛首次夺得的大奖！',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont55 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont55 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont55 (3).jpg')+
          '">'
        },
        {
          title:'数聚智连斩获抖音电商品牌服务商认证！',
          id:'news12',
          img:require('../../assets/img/news/54.png'),
          cont:'近日，抖音电商2023年服务商星级认证完成，北京数聚智连科技股份有限公司作为抖音电商生态伙伴获得“2023年抖音电商铜牌品牌服务商”认证。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont54 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont54 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont54 (3).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont54 (4).jpg')+
          '">'
        },
        {
          title:'数聚智连成功获得ISO9001质量管理体系和ISO27001信息安全管理体系双认证！',
          img:require('../../assets/img/news/53.png'),
          cont:'近日，数聚智连成功获得国家市场监督管理总局登记认证机构做出的ISO9001质量管理体系和ISO27001信息安全管理体系的认证。该体系是国际标准化组织（ISO）颁布的两个重要认证。它们的取得是公司业务发展的重要里程碑，也是我们对客户承诺质量和安全的体现。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont53 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont53 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont53 (3).jpg')+
          '">'
        },
        {
          title:'东连科技连续四年荣获京东“京卓越”大奖！',
          img:require('../../assets/img/news/52.png'),
          cont:'近日，京东公布2022年度京东服务市场“京卓越”服务商获奖名单，各个奖项花落各家。东连科技凭借专业的服务能力及优质的消费者口碑从数千家候选团队中脱颖而出，荣获2022年度“京卓越”代运营服务商奖。东连科技连续四年获得京东“京卓越”奖项，充分展现了京东官方对东连科技运营能力的高度认可。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont52 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont52 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont52 (3).jpg')+
          '">'
        },
        {
          title:'数聚智连荣获2022年度大中华区艾菲效果营销奖专项金奖',
          id:'news15',
          img:require('../../assets/img/news/51.png'),
          cont:'近日，2022年度大中华区艾菲效果营销奖获奖名单正式公布，数聚智连凭借多年优秀的营销实力，从诸多代理公司中脱颖而出，在仅有的6枚金奖中占得一席，荣获专项类金奖。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont51 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont51 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont51 (3).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont51 (4).jpg')+
          '">'
        },
        {
          title:'数聚智连斩获樱桃大赏“年度母婴TP服务商杰出表现大奖”！',
          img:require('../../assets/img/news/50.png'),
          cont:'在12月27日举办的“做好一件事·2022第八届未来母婴大会暨樱桃大赏颁奖盛典”上，数聚智连凭借在母婴行业多年的专业积淀、深度精耕，荣获樱桃大赏“年度母婴TP服务商杰出表现大奖”。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont50 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont50 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont50 (3).jpg')+
          '">'
        },
        {
          title:'数聚智连荣获2022年度TBI杰出品牌创新奖！',
          img:require('../../assets/img/news/49.png'),
          cont:'2022年12月15日，2022年度TBI杰出品牌创新节暨创新奖颁奖典礼于上海落下帷幕。数聚智连从高达1098件参赛作品中脱颖而出，荣获年度营销案例类两项大奖。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont49 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont49 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont49 (3).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont49 (4).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont49 (5).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont49 (6).jpg')+
          '">'
        },
        {
          title:'数聚智连喜获第十五届金投赏三个奖项',
          img:require('../../assets/img/news/48.png'),
          cont:'2022年11月25日，第十五届金投赏国际创意节圆满落幕，2022金投赏商业创意奖最终获奖榜单揭晓，数聚智连喜获三个奖项。',
          detailsVideo:true,
          id:'news20250326',
          video:'<img src="'
          +require('../../assets/img/news/cont48 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont48 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont48 (3).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont48 (4).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont48 (5).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont48 (6).jpg')+
          '">'
        },
        {
          title:'东连科技荣获2022年京东美妆“最佳合作伙伴奖”！',
          id:'news19',
          img:require('../../assets/img/news/47.png'),
          cont:'2022年10月18日，京东美妆服务商大会在线上圆满召开，东连科技有幸受邀参会，并在众多美妆商家中脱颖而出，荣获2022年京东美妆“最佳合作伙伴奖”。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont47 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont47 (1).jpg')+
          '">'
        },
        {
          title:'数聚智连获4季度天猫国际金星服务商 两大优势获认可！',
          img:require('../../assets/img/news/46.png'),
          cont:'天猫国际“2022年·第4季度天猫星级服务商”榜单新鲜出炉！数聚智连凭借独特的跨境电商服务理念及卓越的精细化运营能力再次脱颖而出，荣获「天猫国际金星服务商」称号，彰显出数聚智连在电商领域的硬实力！',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont45 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont45 (3).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont45 (1).jpg')+
          '">'
        },
        {
          title:'2022年数聚智连Blue Oscar颁奖典礼完美收官！',
          img:require('../../assets/img/news/45.png'),
          cont:'2022年数聚智连第四届Blue Oscar颁奖典礼于9月2日圆满落幕。Blue Oscar是全体数聚智连人专属的一年一度优秀项目大奖赛。旨在竞赛中激励营销创新、点燃营销热情，在碰撞中提升整体营销实力，深度贯彻“用户增长、消费增长、行业增长”的三大增长定位。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont45_01.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont45_02.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont45_03.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont45_04.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont45_05.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont45_06.jpg')+
          '">'
        },
        {
          title:'2021年度“京卓越”奖项名单公布 京东将构筑更开放、公平的服务商生态',
          img:require('../../assets/img/news/44.png'),
          cont:'近日，京东以公平公正和更加细分的评选规则，公布了2021年度JDM服务市场“京卓越”获奖名单，共83家服务商获得代运营、软件服务、内容营销、客服外包等14类“京卓越”奖项，还有18名讲师获得突出贡献奖、最佳导师奖、最佳教练奖。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont44_01.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont44_02.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont44_03.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont44_04.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont44_05.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont44_06.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont44_07.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont44_08.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont44_09.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont44_10.jpg')+
          '">'
        },
        {
          title:'数聚营销喜提2022TopDigital创新营销奖五项大奖！',
          img:require('../../assets/img/news/43.png'),
          cont:'2022年7月14日，第十届 TopDigtal创新营销盛典暨创新营销奖颁奖典礼圆满落幕。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont43_01.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont43_02.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont43_03.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont43_04.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont43_05.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont43_06.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont43_07.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont43_08.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont43_09.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont43_10.jpg')+
          '">'
        },
        {
          title:'数聚智连喜获2022年第22届IAI传鉴国际广告奖三项大奖！',
          img:require('../../assets/img/news/42.png'),
          cont:'近日，第22届 IAI传鉴国际广告奖获奖名单正式揭晓，数聚智连成功斩获一银一铜一优秀三项大奖。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont42_01.png')+
          '"><img src="'
          +require('../../assets/img/news/cont42_02.png')+
          '"><img src="'
          +require('../../assets/img/news/cont42_03.png')+
          '">'
        },
        {
          title:'数聚智连荣获阿里2022 m awards【年度货品经营 | 优胜奖】！',
          img:require('../../assets/img/news/40.png'),
          cont:'2022年4月18日，数聚智连与帮宝适在阿里妈妈发起的全球品牌经营大赏m awards中，经营案例【帮宝适黑金帮潮酷破圈！】，荣获「2022 m awards年度货品经营｜优胜奖」，让我们为这一刻欢庆！',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont40_01.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont40_02.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont40_03.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont40_04.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont40_05.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont40_06.jpg')+
          '">'
        },
        {
          title:'东连科技连续三年荣获京东代运营服务年度奖项-“京卓越”奖！',
          img:require('../../assets/img/news/39.png'),
          cont:'2022年3月31日，京东2021年度JDM服务市场“京卓越”服务商获奖名单公布，各个奖项花落各家。其中，在最引人瞩目的代运营京卓越领域，东连科技凭借专业的服务能力及优质的消费者口碑荣获2021年度代运营“京卓越”合作伙伴奖。这也是东连科技连续三年获得京东“京卓越”代运营奖项，充分展现了官方对东连科技在京东平台运营能力的高度认可。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont39_01.png')+
          '"><img src="'
          +require('../../assets/img/news/cont39_02.png')+
          '"><img src="'
          +require('../../assets/img/news/cont39_03.png')+
          '">'
        },
        {
          title:'数聚智连荣获天猫国际金星服务商，蝉联天猫五星服务商！',
          id:'news27',
          img:require('../../assets/img/news/38.png'),
          cont:'2021下半年天猫星级服务商榜单新鲜出炉，数聚智连凭借优质的服务、强大的运营实力和卓越的业绩，再次脱颖而出，蝉联天猫五星服务商。数聚智连同时荣获天猫国际金星服务商，彰显出数聚智连在电商领域的硬实力！',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont38 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont38 (1).png')+
          '"><img src="'
          +require('../../assets/img/news/cont38 (2).png')+
          '">'
        },
        {
          title:'数聚智连荣获第8届TMA移动营销大奖殊荣！',
          img:require('../../assets/img/news/37.png'),
          cont:'2021年11月26日，第八届TMA移动营销大奖颁奖典礼圆满落幕，数聚智连荣获“年度最具影响力移动营销公司”等四项大奖！',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont37_01.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont37_02.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont37_03.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont37_04.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont37_05.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont37_06.jpg')+
          '"><video width="100%" src="'
          +require('../../assets/img/news/cont37.mp4')+
          '" controls="controls">您的浏览器不支持 video 标签。</video><img src="'+
          '"><img src="'
           +require('../../assets/img/news/cont37_08.jpg')+
          '"><img src="'
           +require('../../assets/img/news/cont37_09.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont37_10.jpg')+
          '">'
        },
        {
          title:'东连科技荣获2021双十一“JDM服务市场”双上榜服务商！',
          img:require('../../assets/img/news/36.png'),
          cont:'随着14日双十一返场活动的结束，2021年度购物盛宴“京东11.11”正式落下帷幕。京东平台以同比增长28.6%的高增长率，完成3,491亿元的销售额，为广大消费者带来了一场史无前例的购物狂欢节。作为京东服务帮连续两年的“京卓越奖”获得者，在此次京东服务商市场官方进行的评选中，东连科技再次获得“亿元联盟”俱乐部成员称号，这是东连科技第三次在双十一大促后获此殊荣，此外，在今年的“创新拓展”奖项评选中，东连再次上榜，成为了双上榜服务商，东连的服务能力得到了京东官方极大的认可。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont3601.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3602.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3603.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3604.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3605.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3606.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3607.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3608.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3609.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3610.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3611.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3612.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3613.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3614.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3615.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3616.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3617.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3618.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3619.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3620.jpg')+
          '">'
        },
        {
          title:'一金二银三项大奖，数聚智连在第八届蒲公英盛典大放异彩！',
          img:require('../../assets/img/news/35.png'),
          cont:'2021年10月30日，第十届中国传播领袖论坛暨蒲公英盛典在北京昆泰酒店圆满落幕，第八届蒲公英奖获奖名单亦随之公布。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont35 (1).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont35 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont35 (3).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont35 (4).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont35 (5).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont35 (6).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont35 (7).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont35 (8).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont35 (9).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont35 (10).jpg')+
          '">'
        },
        {
          title:'数聚智连荣获第十四届金投赏两项佳奖',
          img:require('../../assets/img/news/34.png'),
          cont:'2021年10月15日，第十四届金投赏颁奖典礼圆满落幕，数聚智连为博朗和Olay品牌打造的项目——《我把剃须刀做成了战争机器》和《Olay再见松弛，再现紧致》荣获两项佳奖。这是数聚智连品效一体营销实力最强有力鉴证，也是整个营销行业对以电商运营为主体业务的创新电商公司在效果营销领域卓越能力的极大认可！',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont34 (2).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont34 (3).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont34 (4).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont34 (5).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont34 (6).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont34 (7).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont34 (8).jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont34 (9).jpg')+
          '"><video width="100%" src="'
          +require('../../assets/img/news/cont34.mp4')+
          '" controls="controls">您的浏览器不支持 video 标签。</video><img src="'+
          '"><img src="'
          +require('../../assets/img/news/cont34 (10).jpg')+
          '">'
        },
        {
          title:'中科评测将推质检联盟平台 以可信标签为消费者提供安心保障',
          img:require('../../assets/img/news/33.png'),
          cont:'中科评测下一步将联合农业农村部下属中国优质农产品开发服务协会开展茶叶产业数字化建设，孵化优质茶叶品牌，并联合中国文化传媒集团直属中传万卷（北京）公司，在旅游景区产品的数字化建设、主播培训基地、主播认证证书数字化认证等方面进行深度合作。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont33_01.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont33_02.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont33_03.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont33_04.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont33_05.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont33_06.jpg')+
          '">'
        },
        {
          title:'2021年数聚智连Blue Oscar颁奖典完美收官！',
          img:require('../../assets/img/news/32.png'),
          cont:'2021数聚智连Blue Oscar颁奖典礼于9月29日顺利举行。本次我们采用线上线下直播接入的方式进行，北京设立线下主会场，杭州、广州、上海分别设立线上分会场，为2020下半年-2021上半年度公司最有代表性的营销作品及团队颁奖。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont32_01.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont32_02.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont32_03.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont32_04.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont32_05.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont32_06.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont32_07.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont32_08.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont32_09.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont32_10.jpg')+
          '">'
        },
        {
          title:'东连科技蝉联京东2020年度代运营最高奖项！',
          img:require('../../assets/img/news/31.png'),
          cont:'2018年数聚智连正式布局京东代运营业务，公司以客户为核心，为实现中国电商全平台覆盖服务，分拆出“东连科技”为主体公司专注服务京东业务。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont3101.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3102.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3103.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3104.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3105.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3106.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3107.jpg')+
          '">'
        },
        {
          title:'四项大奖 | 数聚营销荣获TopDigital创新营销奖年度营销服务公司大奖及金银铜案例奖！',
          img:require('../../assets/img/news/30.png'),
          cont:'2021年7月7日，备受瞩目的2021 TopDigtal创新营销盛典暨创新营销奖颁奖典礼在上海圆满落幕。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont3001.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3002.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3003.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3004.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3005.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3006.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont3007.jpg')+
          '">'
        },
        {
          title:'数聚智连荣获“天猫母婴亲子2021年上半年推荐榜单”TOP服务商！',
          img:require('../../assets/img/news/29.png'),
          cont:'2021年5月14日，天猫母婴亲子正式发布“2021年上半年优秀服务商推荐榜单”，数聚智连凭借在母婴亲子领域的优秀运营服务能力，荣获上半年TOP服务商荣誉。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont2901.jpg')+
          '">'
        },
        {
          title:'数聚智连荣获第12届金鼠标数字营销大赛两项大奖',
          img:require('../../assets/img/news/28.png'),
          cont:'2021年4月23日，在第12届金鼠标数字营销大赛颁奖盛典上，数聚智连凭借POP MART X小黑盒“潮FUN新街区”电商站内互动小程序和OLAY身体精华小黑盒，荣获电商营销类和效果营销类两项大奖！',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont2801.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont2802.jpg')+
          '">'
        },
        {
          title:'数聚智连蝉联天猫母婴亲子最佳运营服务商',
          img:require('../../assets/img/news/27.png'),
          cont:'2021年4月15日,第四届天猫母婴亲子行业峰会暨金婴奖颁奖盛典在杭州盛大开启。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont2701.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont2702.jpg')+
          '">'
        },
        {
          title:'数聚智连再获天猫五星服务商',
          img:require('../../assets/img/news/26.png'),
          cont:'近日，天猫公布“2020下半年天猫星级运营服务商”评选结果，数聚智连凭借优质的服务、强大的运营实力和卓越的业绩，再次脱颖而出，蝉联天猫五星级服务商。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont2601.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont2602.jpg')+
          '">'
        },
        // {
        //   img:require('../../assets/img/news/25.png'),
        //   +require('../../assets/img/news/cont2501.jpg')+'">'
        //  新闻链接：https://mp.weixin.qq.com/s?__biz=MzIyNjIyNTQ0NQ==&mid=2247486311&idx=1&sn=53526645e0561dc0fbc5984d9b61932a&chksm=e872f72ddf057e3b4c8d850a63c46b191da0b311f8c429113653d6a036518b8e1e0438f35ec4&scene=126&sessionid=1608110972&key=3172bc5cb08cf5502e7b355f9439b4eebccaf208cf185480e31f35a76e7f5dbe696f63de2661fc57131df55105cd89d14f64f23d95f42cd5463d2ae0c088b344072d0b240be7f6fa131fc2650eef053ba6411555021de6c0668ac9ee4bf594cc93744d0866f0065767681af6ba9846143e5b67a91f6191ddc1fe071a1e2079f7&ascene=1&uin=MjI2NDE1MjQwOA%3D%3D&devicetype=Windows+10+x64&version=6300002f&lang=zh_CN&exportkey=AaRHKxyYKGoa%2F5tgnj2YjGw%3D&pass_ticket=NzSPJ88vm4ZfiAHgz1XvAiQOE2KdtiPyIT2A%2F3kUky6lBgilkwhR0XafsEz5A64k&wx_header=0
        // },
        // {
        //   title:'数聚品效助力京东数坊，为品牌提供长时效的品效贡献',
        //   img:require('../../assets/img/news/24.png'),
        //   cont:'近日，根据对品牌历史的数坊分析，数聚品效发现：品牌方在“618”“1111”等大促期间沉淀的4A用户资产，将在后续的半年内持续为品牌贡献GMV。',
        //   detailsVideo:true,
        //   video:'<img src="'
        //   +require('../../assets/img/news/cont2401.jpg')+'">'
        // },
        {
          title:'松下携手数聚智连再谱新零售愿景，18城30店正式登陆',
          img:require('../../assets/img/news/24.png'),
          cont:'2020年12月24日，松下照明30家新零售门店同步上线，正式登陆天猫。门店位置覆盖北京、天津、西安等18个城市，让消费者借由“新零售”这一形式，打破时间与空间束缚，实现全新的消费购物体验。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont2401.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont2402.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont2403.jpg')+
          '">'
        },
        {
          title:'拟创业板挂牌上市，数聚智连完成洪泰基金领投的近亿元Pre-IPO轮融资',
          img:require('../../assets/img/news/23.png'),
          cont:'数聚智连于今日宣布完成近亿元Pre-IPO轮融资，启动上市辅导。本轮融资由洪泰基金领投，险峰旗云跟投，所募集资金将主要用于新项目的孵化，加速企业发展。同时，数聚智连已同瑞信方正证券签署上市辅导协议，并于近日在北京证监局备案，拟创业板挂牌上市。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont2301.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont2302.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont2303.jpg')+
          '">'
        },
        {
          title:'三金三银的好成绩！数聚智连在蒲公英盛典大放异彩！',
          img:require('../../assets/img/news/22.png'),
          cont:'近日，蒲公英2020盛典暨第七届中国创新传播大赛颁奖典礼在北京临空皇冠假日酒店隆重举办，本届大赛共产生案例类策略、内容、渠道、区域、CSR、创新、疫情等七个子项43个类别案例类奖项41个金奖、91个银奖和若干单项奖，以及非案例类奖项。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont2201.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont2202.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont2203.jpg')+
          '">'
        },
        {
          title:'18.46亿！2020数聚智连双十一超级战报来了！',
          img:require('../../assets/img/news/21.png'),
          cont:'2020年双11数聚智连全平台总成交额突破18.46亿！累计服务411万订单，服务店铺向全球发放了980万件商品，为品牌迎来1,611万新会员/粉丝，共计8个店铺销售额突破亿元，8大品牌在各自平台品类销售第一。荣耀战绩源自品牌、平台、合作伙伴的共同耕耘。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont210.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont211.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont212.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont213.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont214.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont215.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont216.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont217.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont218.jpg')+
          '">'
        },
        {
          title:'京东美妆联盟权威认证，数聚智连荣获五星优质商家称号',
          img:require('../../assets/img/news/20.png'),
          cont:'近日，在京东Q3季度“美力联盟”打分评选中，数聚智连旗下专业服务京东平台的品牌-东连科技以绝对的优势脱颖而出，综合评分独占优势，被京东美妆认证为五星优质商家，成为TOP5之一。',
          details:true,
          deta:require('../../assets/img/news/cont20.jpg')
        },
        {
          title:'创新电商公司在国际创意节崭露头角，数聚智连捧获金投赏“双料”金奖！',
          img:require('../../assets/img/news/19.png'),
          cont:'金投赏自2008年创建于中国上海，经过13届的发展与沉淀，已经发展成亚洲规模最大的奖项，也是在全球最有影响力的中国本土的国际化奖项。每年超过几百家专业的设计、广告、媒体公司将其年度最优秀作品及案例参与金投赏的评选，这些作品无论是数量还是质量，在大中国地区均是首屈一指。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont1901.jpg')+
          '"><video width="100%" src="'
          +require('../../assets/img/news/cont19.mp4')+
          '" controls="controls">您的浏览器不支持 video 标签。</video><img src="'
          +require('../../assets/img/news/cont1902.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont1903.jpg')+
          '">'
        },
        {
          title:'数聚智连‘‘Kindle 聚划算欢聚日’’案例斩获多项TOP级广告营销大奖！',
          img:require('../../assets/img/news/18.png'),
          cont:'2020年数聚智连数字营销第三事业部的 #面上有光#Kindle欢聚日方案，凭借精准的洞察创意以及卓越的传播效果，收获各大广告营销大赛四项大奖，包括金鼠标金奖、IAI国际广告奖金奖、TopDigital 银奖以及金瞳奖铜奖。',
          details:true,
          deta:require('../../assets/img/news/cont18.jpg')
        },
        {
          title:'数聚智连荣获2020年第二季度天猫消费者运营相关奖项！',
          img:require('../../assets/img/news/17.png'),
          cont:'2020年第二季度天猫消费者运营于8月最后一周公布相关奖项，数聚智连消费者运营中心团队首次参赛，获得新锐品牌服务商称号，同时也成为消费者运营场景（基础能力）服务商。',
          details:true,
          deta:require('../../assets/img/news/cont17.jpg')
        },
        {
          title:'2020年数聚智连Blue Oscar颁奖典礼',
          img:require('../../assets/img/news/16.png'),
          cont:'2020年数聚智连Blue Oscar颁奖典礼于8月13日顺利举行。本次我们采用线上线下直播接入的方式进行，北京设立线下主会场，上海、杭州、广州分别设立线上分会场，为在2020年上半年表现优秀的作品、团队及个人颁奖。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont601.jpg')+
          '"><video width="100%" src="'
          +require('../../assets/img/news/cont611.mp4')+
          '" controls="controls">您的浏览器不支持 video 标签。</video><img src="'
          +require('../../assets/img/news/cont602.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont603.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont604.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont605.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont606.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont607.jpg')+
          '"><video width="100%" src="'
          +require('../../assets/img/news/cont612.mp4')+
          '" controls="controls">您的浏览器不支持 video 标签。</video><video width="100%" src="'
          +require('../../assets/img/news/cont613.mp4')+
          '" controls="controls">您的浏览器不支持 video 标签。</video><video width="100%" src="'
          +require('../../assets/img/news/cont614.mp4')+
          '" controls="controls">您的浏览器不支持 video 标签。</video><img src="'
          +require('../../assets/img/news/cont608.jpg')+
          '">'
        },
        {
          title:'数聚智连荣获第八届Topdigital创新营销案例奖三大奖项！',
          img:require('../../assets/img/news/15.png'),
          cont:'7月2日，第八届Topdigital创新营销案例奖颁奖，数聚智连分别获得场景营销、社会化营销及智能营销三大类别金银铜大奖。',
          details:true,
          deta:require('../../assets/img/news/cont9.jpg')
        },
        {
          title:'数聚智连荣获第11届金鼠标奖四项大奖',
          img:require('../../assets/img/news/14.png'),
          cont:'近日，第11届金鼠标数字营销大赛奖名单正式揭晓，数聚智连参赛的四个项目，分别从社交媒体话题营销、创意内容传播、电商整合营销、公益营销四个维度荣获四项大奖。',
          detailsVideo:true,
          video:'<img src="'
          +require('../../assets/img/news/cont1401.jpg')+
          '"><img src="'
          +require('../../assets/img/news/cont1402.jpg')+
          '"><video width="100%" src="'
          +require('../../assets/img/news/cont1401.mp4')+
          '" controls="controls">您的浏览器不支持 video 标签。</video><img src="'
          +require('../../assets/img/news/cont1403.jpg')+
          '"><video width="100%" src="'
          +require('../../assets/img/news/cont1402.mp4')+
          '" controls="controls">您的浏览器不支持 video 标签。</video><img src="'
          +require('../../assets/img/news/cont1404.jpg')+
          '"><video width="100%" src="'
          +require('../../assets/img/news/cont512.mp4')+
          '" controls="controls">您的浏览器不支持 video 标签。</video><img src="'
          +require('../../assets/img/news/cont1405.jpg')+
          '">'
        },
        {
          title:'【无奋斗，不青春】2020年618大促数聚智连全平台达成12.06亿元，同比增长+62.8%',
          img:require('../../assets/img/news/13.png'),
          cont:'荣耀战绩源自品牌、平台、合作伙伴的共同奋斗，是热血青春最精彩的绽放！',
          details:true,
          deta:require('../../assets/img/news/cont8.jpg')
        },
        {
          title:'数聚智连携手松下照明共同探索新零售天地',
          img:require('../../assets/img/news/12.png'),
          cont:'松下照明与数聚智连新零售战略合作签约仪式于2020年5月29日，在京顺利举行。北京数聚智连科技股份有限公司董事长熊鲲先生、松下住建空间事业部照明BU长&PMFBJ总经理向井达哉出席签约仪式，并签订战略协议。本次签约标志着两大企业在新零售层面展开战略性的合作。未来将助力松下照明全国经销商赢得更好的市场成绩。',
          details:true,
          deta:require('../../assets/img/news/cont7.jpg')
        },
        {
          title:'数聚智连成功斩获2020年第20届IAI国际广告奖四项大奖',
          img:require('../../assets/img/news/10.png'),
          cont:'近日，第20届 IAI国际广告奖获奖名单正式揭晓，数聚智连Kindle盖泡面聚划算欢聚日、Olay白天鹅计划、飞鹤宝宝日公关活动、千年敦煌无声守护公益活动四个项目成功斩获四项大奖。',
          detailsVideo:true,
          video:'<img src="'+require('../../assets/img/news/cont501.jpg')+'"><video width="100%" src="'+require('../../assets/img/news/cont513.mp4')+'" controls="controls">您的浏览器不支持 video 标签。</video><img src="'+require('../../assets/img/news/cont502.jpg')+'"><video width="100%" src="'+require('../../assets/img/news/cont512.mp4')+'" controls="controls">您的浏览器不支持 video 标签。</video><img src="'+require('../../assets/img/news/cont503.jpg')+'">'
        },
        {
          title:'数聚智连荣获2020年度天猫母婴亲子最佳运营服务商奖',
          img:require('../../assets/img/news/11.png'),
          cont:'2020年5月21日第三届天猫母婴亲子行业峰会暨金婴奖颁奖盛典在杭州举行，数聚智连作为行业领先的以效果营销驱动销售的整合型品牌运营公司受邀参会，并荣获本届大会最具影响力及权威性的奖项——【2020年度天猫母婴亲子最佳运营服务商】，数聚智连COO Anna Yuan代表公司上台接受了颁奖。同时，数聚智连在天猫运营的品牌帮宝适和雅培等也获得了多项大奖，闪耀全场。',
          details:true,
          deta:require('../../assets/img/news/cont6.jpg')
        },
        {
          title:'数聚智连嘉士伯1664项目荣获天猫酒水商家双项先锋奖',
          img:require('../../assets/img/news/9.png'),
          cont:'天猫2020年酒水商家大会于5月14日在线上直播举行，众多商家参与了此次会议。由数聚智连操盘的项目【kronenbourg1664旗舰店】，在本会议中荣获【内容运营&直播先锋】【消费者运营先锋】双项荣誉，这是数聚智连2020年4月至今的第三次获奖，再一次印证了数聚智连卓越的运营实力。',
          details:true,
          deta:require('../../assets/img/news/cont4.jpg')
        },
        {
          title:'数聚智连获京东代运营2019年度最高奖项',
          img:require('../../assets/img/news/8.png'),
          cont:'2018年数聚智连正式布局京东代运营业务，以客户为核心，实现中国电商全平台服务，单独成立和分拆东连科技专注服务京东业务。经过两年不断的学习及突破，继荣获2019年天猫、天猫国际五星级服务商之后，数聚智连再次斩获京东平台代运营最高奖项：2019年代运营“京卓越”合作伙伴，实现2019年全平台顶级认可。同时，通过2020年京东数坊ISV进阶能力认证考核，数聚智连荣获京东数坊中级认证，加上已经获得的天猫数据银行ISV认证，数聚智连实现跨平台的数据ISV认证。',
          details:true,
          deta:require('../../assets/img/news/cont3.jpg')
        },
        {
          title:'数聚智连（原蓝标电商）再斩获天猫国际重磅奖项',
          img:require('../../assets/img/news/7.png'),
          cont:'4月16日，TG1000天猫国际2020全球合作伙伴盛典（Tmall Global 2020 Global Partners Summit）在线上如约举行，全球千余个商家在线上共同观看了此次盛典。由数聚智连（原蓝标电商）操盘的《博朗天猫海外旗舰店》，在众多品牌中脱颖而出，再次荣获天猫国际赋予的两项大奖：《2020财年最佳用户体验奖》、《2020财年亿元俱乐部》。这是继2018财年获得《2018财年新锐店铺奖》后又一次荣获天猫国际平台给予的殊荣，再次印证了公司对于天猫国际平台的运营实力。',
          details:true,
          deta:require('../../assets/img/news/cont2.jpg')
        },
        {
          title:'数聚智连2019双11销售首破十亿',
          img:require('../../assets/img/news/0.png'),
          cont:'燃烧青春，十分得亿。2019年双11大促落下帷幕，数聚智连全平台销售额首破十亿，达到创纪录的11.78亿。荣耀战绩源自品牌、平台、合作伙伴的共同耕耘，感谢大家与我们一起奋战，你们的支持是我们最大的鼓励！',
          details:true,
          deta:require('../../assets/img/news/cont1.jpg')
        },
        {
          title:'电商 2.0 时代!全球彩妆专家 MBB 集团与数聚智连正式成立国内合资公司，发力中国市场',
          img:require('../../assets/img/news/1.png'),
          cont:'2019 年 6 月 6 日，总部位于洛杉矶的美国最大私人持有的彩妆集团 Markwins Beauty Brands (MBB)与北京数聚智连科技股份有限公司(原蓝标电商)强强联合，签署战略合作协议，成立合资企业 Markwins Blue Beauty Co. Limited，携手布局中国市场，以新型商业模式发力中国市场，加速 MBB 旗下品牌在中国的开拓与发展，Z世代快美妆，未来可期。'
        },
        {
          title:'蓝标电商更名为北京数聚智连科技股份有限公司',
          img:require('../../assets/img/news/2.png'),
          cont:'从2019年1月1日开始，北京蓝标光标电子商务股份有限公司正式更名为北京数聚智连科技股份有限公司。我们希望在数字化和电商化的年代，对数据更好的聚合和优化，更好的连接品牌与中国市场，连接品牌营销与销售，连接品牌与平台，来帮客户实现最佳的营销销售投资回报率（ROI）这一梦想和使命。自蓝标电商成立以来，我们已经成长为一个在母婴，3C小家电，个护美妆和食品领域领先的营销驱动销售的新一代电商营销公司。来自北联伟业，博思瀚扬和蓝标集团的超过600个小伙伴，在北京、上海、杭州和广州四个办公室，为超过60个国际知名的品牌和企业提供效果营销和电商运营的服务，一年创造30亿的GMV，成为一家在新三板挂牌的透明，合规的公众公司。'
        },
        {
          title:'双11战报出炉,蓝标电商9.88亿再创新纪录',
          img:require('../../assets/img/news/3.png'),
          cont:'2018年蓝标电商双11取得了傲人的成绩，这是我们扬帆的开始，更是我们启航的起点，2019年我们更值得期待！砥砺十年，我们携手走过；未来的日子，让我们共同创造更精彩的故事！特别感谢，所有战斗在一线的蓝电侠们，感谢公司所有团队和小伙伴的努力付出和全情投入，感谢你们的支持和陪伴，因为有你们，才有蓝标电商辉煌的今天和灿烂的未来！特别感谢，所有品牌方和合作伙伴的鼎力相助，倾力配合，是你们的全力支持，让我们所向披靡，战无不胜！'
        },
        {
          title:'蓝标电商荣获2018年天猫五星服务商称号',
          img:require('../../assets/img/news/4.png'),
          cont:'蓝标电商凭借综合实力，在2018年8月荣获天猫五星服务商称号，蓝标电商借助品牌数据银行，运用高效整合的运营理念，与消费者形成优质互动，并赢得数以万计新老粉丝的支持评论与点赞，牢牢抓住目标消费群，扎实了销售能力。未来的蓝标电商将继续以效果营销驱动销售，提供从品牌中国策略，品牌效果营销，线下整合零售和包括供应链在内的整合电商服务，为所服务的客户实现品牌与中国市场的连接，实现营销与销售的连接，实现品牌和电商平台的连接。'
        },
        {
          title:'蓝标电商2018上半年营收4.31亿元 净利1733万元',
          img:require('../../assets/img/news/5.png'),
          cont:'09月18日消息，蓝标电商（证券代码：837467）近日公布的2018年半年报显示，截至2018年6月30日，企业实现营收4.31亿元;归属于挂牌公司股东的净利润为1733万元。'
        },
        {
          title:'蓝标电商CEO专访',
          img:require('../../assets/img/news/6.png'),
          cont:'蓝标电商的定位是Performance Marketing，也就是以营销驱动销售。对于品牌而言，电商只是一个平台，最终的目的还是营销。消费者不仅仅是因为流量而选择购买一个品牌，而是因为这个品牌有吸引消费者的地方。蓝色光标集团是以品牌营销、品牌策略著称的公司，对品牌管理、品牌营销策略非常了解，而我们蓝标电商具备集团基因，所以蓝标电商未来的发展模式是要成为以品牌力和效果营销驱动销售的一家公司。我们做的每一件事都是为了效果，我们不讨论长期的品牌调性有多么高大伟大，这个品牌在中国的知名度怎么样，我们强调的是，我们投入一分钱，能给我们的客户带来多少销售。以营销驱动销售，打造高ROI，做可以提高转化率的营销。以效果为导向，形成独特的风景。实现高效营销，回到商业本质帮客户实现销售。'
        },
      ]
    }
  },
  methods: {
    closeD(){
      this.coverageShow = false;
    },
    openD(data){
      this.coverageShow = true;
      this.detaImg = data
      this.htmlNew = ''
    },
    openDV(data){
      this.coverageShow = true;
      this.htmlNew = data
      this.detaImg = ''
    },
    newsClick(data){
      this.newslistIndex = data;
    },
    smoothScrollTo(element) {
        const targetY = element.getBoundingClientRect().top + window.pageYOffset-60;
        const startY = window.pageYOffset;
        const distance = targetY - startY;
        const duration = 500;
        let startTime = null;

        function animate(currentTime) {
          if (!startTime) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          const nextY = ease(timeElapsed, startY, distance, duration);
          window.scrollTo(0, nextY);
          if (timeElapsed < duration) {
            requestAnimationFrame(animate);
          }
        }

        function ease(t, b, c, d) {
          t /= d / 2;
          if (t < 1) return c / 2 * t * t + b;
          t--;
          return -c / 2 * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(animate);
      }
  },
  
  mounted(){
    setTimeout(() => {
      
      console.log(this.$route.query.data)
      const element = document.getElementById(this.$route.query.data);
      this.smoothScrollTo(element)
      
      this.Jujiao = this.$route.query.data
    }, 0);


    // this.$listenScroll(({ top }) => {
    //     console.log('当前滚动位置1：', top)
    //   }, window) // 或 window
      

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less"> 
.news{
  //新闻详情
  .coverage{
    display: inline-block;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 10000;
    margin-top: -106px;
    
    .coverageCont::-webkit-scrollbar {display:none}
    .coverageCont{
      display: inline-block;
      width: 800px;
      height: 70%;
      background: #fff;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      border-radius: 10px;
      box-shadow: 0 0 10px #303030;
      overflow: hidden;
      .coverageScroll{
        display: block;
        width: 817px;
        height: 100%;
        overflow-y: scroll;

        // 鼠标向下滚动的提示
        .xxhd{
          display: inline-block;
          width: 100%;
          height: 100%;
          background:rgba(0, 0, 0, 0.3);
          position: absolute;
          top: 0;
          left: 0;
          pointer-events: none;
              .xxhdText{
                display: block;
                height: 80px;
                text-align: center;
                color: rgba(255, 255, 255, 1);
                font-size: 14px;
                position: absolute;
                left: 0;
                right: 0;
                bottom: -180px;
                top: 0;
                margin: auto;
              }
              .scroll-icon {
                  display: -webkit-box;
                  display: -ms-flexbox;
                  display: flex;
                  -webkit-box-pack: center;
                  -ms-flex-pack: center;
                  justify-content: center;
                  -webkit-box-align: center;
                  -ms-flex-align: center;
                  align-items: center;
                  height: 60px;
                  width: 30px;
                  font-size: 22px;
                  color: rgba(255, 255, 255, 1);
                  border-radius: 60px;
                  border: solid 2px;
                  -webkit-transition: .4s;
                  transition: .4s;
                  position: absolute;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  top: 0;
                  margin: auto;
              }
              .scroll-icon:hover {
                  background-color: rgba(255, 255, 255, 0.05);
                  color: #fff;
              }
              .scroll-icon::after {
                  content: '';
                  width: 10px;
                  height: 10px;
                  background-color: #fff;
                  border-radius: 50%;
                  -webkit-animation: scroll-icon 2.2s infinite cubic-bezier(0.65, 0.05, 0.36, 1);
                  animation: scroll-icon 2.2s infinite cubic-bezier(0.65, 0.05, 0.36, 1);
              }
              @-webkit-keyframes scroll-icon {
                  0% {
                      -webkit-transform: translateY(-12px);
                      transform: translateY(-12px);
                      opacity: 0;
                  }
                  30%,
                  70% {
                      opacity: 1;
                  }
                  100% {
                      -webkit-transform: translateY(12px);
                      transform: translateY(12px);
                      opacity: 0;
                  }
              }
              @keyframes scroll-icon {
                  0% {
                      -webkit-transform: translateY(-12px);
                      transform: translateY(-12px);
                      opacity: 0;
                  }
                  30%,
                  70% {
                      opacity: 1;
                  }
                  100% {
                      -webkit-transform: translateY(12px);
                      transform: translateY(12px);
                      opacity: 0;
                  }
                }
                          
                animation: xxgdAni 5s;
                -moz-animation: xxgdAni 5s;	/* Firefox */
                -webkit-animation: xxgdAni 5s;	/* Safari 和 Chrome */
                -o-animation: xxgdAni 5s;	/* Opera */
                opacity: 0;
        }
        @keyframes xxgdAni
        {
          0% {opacity:1;}
          80%{opacity:1;}
          100% {opacity: 0;}
        }

        @-moz-keyframes xxgdAni /* Firefox */
        {
          0% {opacity:1;}
          80%{opacity:1;}
          100% {opacity: 0;}
        }

        @-webkit-keyframes xxgdAni /* Safari 和 Chrome */
        {
          0% {opacity:1;}
          80%{opacity:1;}
          100% {opacity: 0;}
        }

        @-o-keyframes xxgdAni /* Opera */
        {
          0% {opacity:1;}
          80%{opacity:1;}
          100% {opacity: 0;}
        }
        //滚动提示结束 
        .closeD{
          display: inline-block;
          width: 160px;
          height:60px;
          background:#0168b7;
          color: #fff;
          position: absolute;
          right: -65px;
          top: -15px;
          font-size: 30px;
          line-height:60px;
          text-align: center;
          transform:rotate(45deg);
          -ms-transform:rotate(45deg); 	/* IE 9 */
          -moz-transform:rotate(45deg); 	/* Firefox */
          -webkit-transform:rotate(45deg); /* Safari 和 Chrome */
          -o-transform:rotate(45deg); 	/* Opera */
          cursor: pointer;
          box-shadow: 0 0 10px #303030;
        }
        img{
          display: block;
          width: 100%;
        }
      }
    }
    animation: coverAni 1s;
    -moz-animation: coverAni 1s;	/* Firefox */
    -webkit-animation: coverAni 1s;	/* Safari 和 Chrome */
    -o-animation: coverAni 1s;	/* Opera */
  }
  @keyframes coverAni
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-moz-keyframes coverAni /* Firefox */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-webkit-keyframes coverAni /* Safari 和 Chrome */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-o-keyframes coverAni /* Opera */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }
  // 第二屏
  .clientCon2{
    height: 100px;
    position: relative;
    margin-top: 0 !important;
    .clientAbout{
      display: inline-block;
      width: 360px;
      height: 100px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      font-size: 38px;
      color: #555;
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
      text-align: center;
      // opacity: 0;
      .clientAbout_top{
        display: inline-block;
        width: 100%;
        font-size: 32px;
        font-weight: 900;
      }
      .clientAbout_bot{
        display: inline-block;
        width: 100%;
        font-size: 22px;
        background: url('../../assets/img/client/down.png') no-repeat 230px;
        font-weight: 900;
      }
      p{
        display: inline-block;
        background: #0168b7;
        width: 40px;
        height: 2px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0 auto;
      }
    }

  }


  box-sizing: border-box;
  .swiperImg{
    width: 100%;
    min-width: 1200px;
  }
  /*//轮播入场*/
  .swiper-container{
    animation: swiperRc 2s;
    -moz-animation: swiperRc 2s;	/* Firefox */
    -webkit-animation: swiperRc 2s;	/* Safari 和 Chrome */
    -o-animation: swiperRc 2s;	/* Opera */
    width: 1200px;
  }
  @keyframes swiperRc
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-moz-keyframes swiperRc /* Firefox */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-webkit-keyframes swiperRc /* Safari 和 Chrome */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-o-keyframes swiperRc /* Opera */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }
  .newsCon11{
    height: 400px;
    background: #fff;
    .newsCon11_right,.newsCon11_left{
      display: inline-block;
      height: 100%;
      width: 50%;
      float: left;
      border: none;
    }
  }
  .newsCon11_left{
    position: relative;
    img{
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
      width: 20%;
      animation: insuran11SF 5s;
      -moz-animation: insuran11SF 5s;	/* Firefox */
      -webkit-animation: insuran11SF 5s;	/* Safari 和 Chrome */
      -o-animation: insuran11SF 5s;	/* Opera */
    }
    @keyframes insuran11SF
    {
      from {
      transform:scale(1.2);
      -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
      }
      to {
      transform:scale(1);
      -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
      }
    }

    @-moz-keyframes insuran11SF /* Firefox */
    {
      from {
      transform:scale(1.2);
      -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
      }
      to {
      transform:scale(1);
      -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
      }
    }

    @-webkit-keyframes insuran11SF /* Safari 和 Chrome */
    {
      from {
      transform:scale(1.2);
      -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
      }
      to {
      transform:scale(1);
      -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
      }
    }

    @-o-keyframes insuran11SF /* Opera */
    {
      from {
      transform:scale(1.2);
      -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
      }
      to {
      transform:scale(1);
      -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
      }
    }
    .newsAbout{
      display: inline-block;
      width: 200px;
      height: 100px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      font-size: 38px;
      color: #555;
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
      animation: swiperRc 3s;
      -moz-animation: swiperRc 3s;	/* Firefox */
      -webkit-animation: swiperRc 3s;	/* Safari 和 Chrome */
      -o-animation: swiperRc 3s;	/* Opera */
      .newsAbout_top{
        display: inline-block;
        width: 100%;
        font-size: 32px;
        font-weight: 900;
      }
      .newsAbout_bot{
        display: inline-block;
        width: 100%;
        font-size: 22px;
        background: url('../../assets/img/index/right.png') no-repeat right;
        font-weight: 900;
      }
    }
  }
  .newsCon11_right{
    position: relative;
    font-size: 14px;
    line-height: 24px;
    color: #555;
    padding:100px 20px;
    box-sizing: border-box;
  }
  .newsCon11_right>span{
    position: absolute;
    left: 0;
    top: 120px;
    display: inline-block;
    background: #0168b7;
    height: 40px;
    width: 4px;
  }
  .newsCon11::after{
    content: '';
    clear: both;
  }
  // 新闻列表
  .newsCon3{
    background: #fff;
    padding-top: 10px;
    
    .newsCon31{
      width: 1100px;
      
      .jujiaoNewsList{
        animation: showJunews 1s forwards;
        -moz-animation: showJunews 1s forwards;	/* Firefox */
        -webkit-animation: showJunews 1s forwards;	/* Safari 和 Chrome */
        -o-animation: showJunews 1s forwards;	/* Opera */
        animation-delay: 0.5s;
      }
      @keyframes showJunews
      {
        0% {
          background: rgba(242,246,252,1);
        }
        25% {
          background: rgba(247, 247, 247, 0);
        }
        50% {
          background: rgba(242,246,252,1);
        }
        75% {
          background: rgba(247, 247, 247, 0);
        }
        100% {
          background: rgba(242,246,252,1);
        }
      }

      .newsList{
        width: 100%;
        height: 160px;
        background: #f7f7f7;
        background: #fff;
        margin: 10px 0px;
        padding: 10px;
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        border-radius: 10px;
        img{
          height: 100%;
          float: left;
        }
        span{
          display: inline-block;
          
          font-size: 16px;
          float: left;
          width: 100%;
          margin-left: 20px;
          margin-bottom: 0px;
          font-weight: 400;
          color: #1e2128;
          position: relative;
        }
        div{
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        p{
          flex-shrink:1;
          display: inline-block;
          width: 100%;
          font-size: 14px;
          float: left;
          margin-left: 20px;
          color: #80888f;
          line-height: 24px;
          box-sizing: border-box;
          padding-right: 30px;
          text-align: justify; /* 使段落两端对齐 */
          text-align-last: left; /* 最后一行左对齐 */
          text-justify: inter-word; /* 在单词之间添加间距 */
          hyphens: auto; /* 自动断字（可选）  */
          margin-top: 10px;
          margin-bottom: 10px;
          overflow-y: auto;
          
          i{
            display: inline;
            font-size: 12px;
            color: #0168b7;
            white-space: nowrap;
            top: 0;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/news.vue